import { Anchor, Divider, Group, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { ru } from '../i18n/ru';
import { accentText } from '../theme';

const legalLinks = [
  { to: '/terms', label: ru.pages.terms },
  { to: '/privacy', label: ru.pages.privacy },
  { to: '/personal-data', label: ru.pages.personalData },
];

/**
 * Ссылки на правовые документы должны быть доступны с любой страницы:
 * на них ссылается форма оформления абонемента, и их ищут глазами внизу.
 */
export function AppFooter() {
  return (
    <Stack gap="md" mt={64}>
      <Divider />

      <Group justify="space-between" align="flex-start" gap="md" wrap="wrap" pb="md">
        <Group gap="md" wrap="wrap">
          {legalLinks.map((link) => (
            <Anchor key={link.to} component={Link} to={link.to} size="xs" c={accentText}>
              {link.label}
            </Anchor>
          ))}
        </Group>

        <Text size="xs" c="graphite.5">
          {ru.app.title} · {ru.app.subtitle}
        </Text>
      </Group>
    </Stack>
  );
}
